/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Fcexplain1Inputs */

const zh_landing_admin_fcexplain1 = /** @type {(inputs: Landing_Admin_Fcexplain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`线粒体通过细胞呼吸为细胞提供大部分 ATP 能量。`)
};

const en_landing_admin_fcexplain1 = /** @type {(inputs: Landing_Admin_Fcexplain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitochondria generate most of the cell's ATP through cellular respiration.`)
};

const es_landing_admin_fcexplain1 = /** @type {(inputs: Landing_Admin_Fcexplain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las mitocondrias generan la mayor parte del ATP de la célula mediante la respiración celular.`)
};

/**
* | output |
* | --- |
* | "Mitochondria generate most of the cell's ATP through cellular respiration." |
*
* @param {Landing_Admin_Fcexplain1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_fcexplain1 = /** @type {((inputs?: Landing_Admin_Fcexplain1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Fcexplain1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_fcexplain1(inputs)
	if (locale === "en") return en_landing_admin_fcexplain1(inputs)
	return es_landing_admin_fcexplain1(inputs)
});
export { landing_admin_fcexplain1 as "landing_admin_fcExplain" }